import http from "../conf/AxiosConfig.js";
import AppConfig from "@/conf/global.js";

class UtilService {
   copyDetalleLink(link) {
      let href = window.location.href;
      let detalleString = "detalle";
      //console.log(href);
      if (href.includes(detalleString)) {
         href = href.split(detalleString)[0].concat(link);
      } else {
         href = href.concat(link);
      }
      href = href.replaceAll("//", "/").replaceAll(":/", "://");
      //console.log(href);
      navigator.clipboard.writeText(href);
      //document.execCommand("copy");
   }

   async getPdf() {
      return await http.get(AppConfig.pdfDummy, { params: { ruta: "pdf.pdf" } });
   }
}

export default new UtilService();
